/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared quickview snippet. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* capkov-rd (3. 10.): one reusable panel for info pages and the contact form.
   - a click on a link to an info page (/pages/delivery-and-payment, /policies/...) or on mailto: opens the panel on the same page
     (bottom sheet on mobile, side panel on desktop), the customer does not leave the product
   - content: fetch the page, extract the main content (#main without the footer), cache in memory and sessionStorage, load missing CSS
   - accessibility: native <dialog> (modal), focus trap, Esc, focus return, browser Back closes the panel (history.pushState)
   - "Open the full page" is always visible
   - contact form (name, email, order number, message, optional photo) instead of mailto: sends to Gatherino (form capkov-kontakt, market=eu, language=en; honeypot + time trap + limits handled by Gatherino, no captcha)
   Manual call: window.rdDrawer.open('/pages/x'), window.rdDrawer.contact({tema:'reklamace', message:'...'});
   attributes: data-rd-drawer (force; ="off" never), data-rd-contact (open the form), data-tema, data-subject. */
(function () {
  'use strict';
  if (window.rdDrawer) return;

  var CONF = {
    /* GATHERINO: answers from the contact form are hosted by Gatherino (multipart). When going live change ONLY the host:
       gatherino.com -> gatherino.com (the only place in this file). */
    endpoint: 'https://gatherino.com/api/embed/forms/capkov-kontakt/submit',
    /* "Photo" field in the form (Gatherino accepts up to 3 files, 5 MB in total). Switch on only after the look is approved. */
    photos: false,
    instagram: 'https://www.instagram.com/capkov_eu/',
    mail: 'info@capkov.com',
    privacy: '/policies/privacy-policy',
    minMs: 3200
  };

  /* ------------------------------------------------------------ link rules ---- */
  var INFO_PAGES = [
    'delivery-and-payment', 'return-and-refund', 'return-your-order',
    'faq', 'cap-tionary',
    /* 'for-companies-teams' deliberately NOT: the page form (capkov-rd-b2b-form.js) did not initialise in the panel (submit fell back to a native submit), B2B opens normally. 'about-us-reviews' also opens normally (as on CZ). */
    'how-we-embroider-in-the-czech-republic-quality-hat-embroidery-capkov-cz',
    'custom-hats-from-a-trusted-manufacturer-ethics-certifications-capkov-cz',
    'custom-embroidered-hats-your-own-text-and-monogram-capkov-cz'
  ];
  var CONTACT_PAGES = ['contact', 'ask-us'];
  /* page types where links in the content open in the panel (elsewhere only mailto, links with data-rd-drawer and links in the cart) */
  var SCOPE_TYPES = ['product', 'collection', 'cart', 'search'];

  function pageType() { return document.body ? document.body.getAttribute('data-rd-t') || '' : ''; }
  function norm(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (u.origin !== location.origin) return null;
      var p = u.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/(pages|policies)\/)/i, '').replace(/\/+$/, '');
      return { path: p, url: u, key: p };
    } catch (e) { return null; }
  }
  function classify(a) {
    if (!a || !a.getAttribute) return null;
    var h = a.getAttribute('href') || '';
    if (a.getAttribute('data-rd-drawer') === 'off' || a.hasAttribute('data-rd-nodrawer')) return null;
    if (/^mailto:/i.test(h)) return { kind: 'contact', mailto: h };
    if (a.hasAttribute('data-rd-contact')) return { kind: 'contact' };
    var n = norm(a); if (!n) return null;
    var m = n.path.match(/^\/(pages|policies)\/([^/]+)/);
    var forced = a.hasAttribute('data-rd-drawer');
    if (!m) return null;
    var isInfo = m[1] === 'policies' || INFO_PAGES.indexOf(m[2]) > -1;
    var isContact = m[1] === 'pages' && CONTACT_PAGES.indexOf(m[2]) > -1;
    if (!isInfo && !isContact && !forced) return null;
    if (!forced) {
      var inCart = a.closest && a.closest('cart-drawer, #cart-drawer, [id*="cart-drawer"], .rdc-bar, .cart-drawer, [class*="rdc-"]');
      var inChrome = a.closest && a.closest('header, footer, [class*="footer"], [class*="header__"], .rd-bar, nav[aria-label*="main" i], .rdd');
      if (inChrome && !inCart) return null;
      if (SCOPE_TYPES.indexOf(pageType()) < 0 && !inCart) return null;
      if (inCart && !a.closest('.rdd') && false) return null;
    }
    if (isContact) return { kind: 'contact' };
    return { kind: 'page', url: n.url.pathname + n.url.search };
  }

  /* ------------------------------------------------------------ content loading ---- */
  var cache = {}, SS = 'rdd:v3:';
  function ssGet(k) { try { return sessionStorage.getItem(SS + k); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v.length < 400000) sessionStorage.setItem(SS + k, v); } catch (e) { } }
  function hasSheet(href) {
    var p = href.split('?')[0], L = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < L.length; i++) if ((L[i].getAttribute('href') || '').split('?')[0] === p) return true;
    return false;
  }
  function extract(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var secs = [].slice.call(d.querySelectorAll('#main > .shopify-section')).filter(function (s) {
      return !/footer|announcement|header/i.test(s.className + ' ' + s.id);
    });
    var host = d.createElement('div');
    if (secs.length) secs.forEach(function (s) { host.appendChild(s); });
    else { var m = d.querySelector('#main, main, .shopify-policy__container, body'); if (m) host.innerHTML = m.innerHTML; }
    [].forEach.call(host.querySelectorAll('.shopify-section-group-header-group,.shopify-section-group-footer-group,[id*="__header"],[id*="__footer"],[id*="announcement"]'), function (n) { n.remove(); });
    var h1 = host.querySelector('h1');
    var title = (h1 && h1.textContent.trim()) || (d.title || '').split(/[–|\-]\s*(?=[^–|\-]*$)/)[0].trim();
    var css = [].slice.call(d.head.querySelectorAll('link[rel="stylesheet"][href]')).map(function (l) { return l.getAttribute('href'); });
    return { title: title, html: host.innerHTML, css: css };
  }
  function load(url) {
    if (cache[url]) return cache[url];
    var s = ssGet(url);
    if (s) { try { return (cache[url] = Promise.resolve(JSON.parse(s))); } catch (e) { } }
    cache[url] = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'rd-drawer' } }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.text();
    }).then(function (t) {
      var x = extract(t); if (!x.html || x.html.replace(/\s/g, '').length < 40) throw new Error('empty');
      ssSet(url, JSON.stringify(x)); return x;
    });
    cache[url].catch(function () { delete cache[url]; });
    return cache[url];
  }

  /* ------------------------------------------------------------ panel ---- */
  var dlg, bodyEl, titleEl, fullEl, backEl, sheet, opener = null, stack = [], panels = {}, pushed = false, formOpenedAt = 0;

  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'rdd'; dlg.setAttribute('aria-labelledby', 'rdd-t');
    dlg.innerHTML =
      '<div class="rdd__sheet" tabindex="-1">' +
      '<span class="rdd__grab" aria-hidden="true"></span>' +
      '<header class="rdd__bar">' +
      ("<button type=\"button\" class=\"rdd__back\" aria-label=\"" + rdOT("back_b52b36b", "Back", true) + "\" hidden><svg viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 5l-7 7 7 7\"/></svg></button>") +
      '<h2 class="rdd__title" id="rdd-t"></h2>' +
      ("<button type=\"button\" class=\"rdd__x\" aria-label=\"" + rdOT("close_bbfa773", "Close", true) + "\"><svg viewBox=\"0 0 24 24\" width=\"22\" height=\"22\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" aria-hidden=\"true\"><path d=\"M6 6l12 12M18 6L6 18\"/></svg></button>") +
      '</header>' +
      '<div class="rdd__body" data-rdd-body></div>' +
      ("<footer class=\"rdd__foot\"><a class=\"rdd__full\" href=\"#\" hidden>" + rdOT("open_the_full_page_c3ad4b5", "Open the full page ", true) + "<span aria-hidden=\"true\">↗</span></a><button type=\"button\" class=\"rdd__cta\" data-rdd-cta hidden></button></footer>") +
      '</div>';
    document.body.appendChild(dlg);
    sheet = dlg.querySelector('.rdd__sheet'); bodyEl = dlg.querySelector('[data-rdd-body]');
    titleEl = dlg.querySelector('.rdd__title'); fullEl = dlg.querySelector('.rdd__full'); backEl = dlg.querySelector('.rdd__back');
    dlg.querySelector('.rdd__x').addEventListener('click', close);
    backEl.addEventListener('click', function () { if (stack.length > 1) { stack.pop(); show(stack[stack.length - 1]); } });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', trap);
    /* Esc closes only the panel (not the cart below it): catch it before the cart listener */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dlg.open) { e.preventDefault(); e.stopImmediatePropagation(); close(); }
    }, true);
    /* dragging the bottom sheet down (mobile) */
    var y0 = null, dy = 0;
    sheet.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.rdd__grab, .rdd__bar')) return; y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none';
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    sheet.addEventListener('touchend', function () {
      if (y0 === null) return; sheet.style.transition = ''; sheet.style.transform = ''; var go = dy > 90; y0 = null; dy = 0; if (go) close();
    });
    window.addEventListener('popstate', function () {
      if (dlg.open && !(history.state && history.state.rdd)) { pushed = false; hide(); }
    });
    bodyEl.addEventListener('click', onBodyClick);
  }
  function focusables() {
    return [].slice.call(dlg.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"]),summary')).filter(function (e) {
      return !e.disabled && !e.hidden && e.offsetParent !== null && !e.closest('[hidden]');
    });
  }
  function trap(e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    var a = document.activeElement, first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (a === first || a === sheet)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function hide() {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('rdd--in');
    var done = function () { stack = []; try { dlg.close(); } catch (e) { } document.documentElement.classList.remove('rdd-lock'); if (opener && opener.focus && document.contains(opener)) try { opener.focus({ preventScroll: true }); } catch (e) { } };
    setTimeout(done, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 220);
  }
  function close() {
    if (!dlg || !dlg.open) return;
    if (pushed && history.state && history.state.rdd) { history.back(); } else { pushed = false; hide(); }
  }
  function openShell(opener_) {
    build();
    if (!dlg.open) {
      opener = opener_ || document.activeElement;
      stack = [];
      /* panel from the cart: no need to close it, the native dialog is in the top layer above it */
      dlg.showModal(); document.documentElement.classList.add('rdd-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('rdd--in'); }); });
      if (!pushed) { try { history.pushState({ rdd: 1 }, '', location.href); pushed = true; } catch (e) { } }
    }
  }
  function show(entry) {
    [].forEach.call(bodyEl.children, function (c) { c.hidden = c !== entry.panel; });
    titleEl.textContent = entry.title || '';
    backEl.hidden = stack.length < 2;
    if (entry.full) { fullEl.href = entry.full; fullEl.hidden = false; } else fullEl.hidden = true;
    var cta = dlg.querySelector('[data-rdd-cta]');
    if (cta) { cta.hidden = !entry.full; cta.textContent = entry.ctaLabel || CTA_DEFAULT; cta.onclick = function () { openContact({ tema: entry.tema || '' }, opener); }; }
    bodyEl.scrollTop = 0;
    var t = entry.focus ? entry.panel.querySelector(entry.focus) : null;
    if (t) setTimeout(function () { try { t.focus({ preventScroll: true }); } catch (e) { } }, 60); else try { sheet.focus({ preventScroll: true }); } catch (e) { }
  }
  function push(entry) {
    stack.push(entry); show(entry);
  }

  /* ------------------------------------------------------------ pages ---- */
  function rerunScripts(root) {
    [].slice.call(root.querySelectorAll('script')).forEach(function (o) {
      if (o.type && !/javascript|module/.test(o.type)) return;
      if (o.src && document.querySelector('script[src="' + o.getAttribute('src') + '"]')) { o.remove(); return; }
      var n = document.createElement('script');
      [].forEach.call(o.attributes, function (a) { n.setAttribute(a.name, a.value); });
      n.text = o.text; o.parentNode.replaceChild(n, o);
    });
  }
  function openPage(url, from) {
    openShell(from);
    var key = 'p:' + url;
    if (panels[key]) { var ex = stack.filter(function (s) { return s.key === key; })[0]; if (ex) { stack = stack.slice(0, stack.indexOf(ex) + 1); show(ex); return; } }
    var panel = panels[key] || document.createElement('section');
    if (!panels[key]) {
      panel.className = 'rdd__panel'; panel.hidden = true; panel.innerHTML = ("<div class=\"rdd__load\" role=\"status\"><i></i><i></i><i></i><span class=\"rdd-sr\">" + rdOT("loading_33ce417", "Loading…", true) + "</span></div>"); bodyEl.appendChild(panel); panels[key] = panel;
    }
    var entry = { key: key, panel: panel, title: '', full: url };
    push(entry);
    if (panel.getAttribute('data-ready')) { entry.title = panel.getAttribute('data-title'); titleEl.textContent = entry.title; return; }
    load(url).then(function (x) {
      x.css.forEach(function (h) {
        if (!hasSheet(h)) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = h; document.head.appendChild(l); }
      });
      panel.innerHTML = '<div class="rdd__content rdd__content--page">' + x.html + '</div>';
      [].forEach.call(panel.querySelectorAll('img:not([loading])'), function (im) { im.loading = 'lazy'; im.decoding = 'async'; });
      rerunScripts(panel);
      panel.setAttribute('data-ready', '1'); panel.setAttribute('data-title', x.title);
      entry.title = x.title; if (stack[stack.length - 1] === entry) { titleEl.textContent = x.title; bodyEl.scrollTop = 0; }
    }).catch(function () {
      panel.innerHTML = ("<div class=\"rdd__content\"><p class=\"rdd__err\">" + rdOT("the_page_could_not_be_loaded_into_the_panel_2138439", "The page could not be loaded into the panel.", true) + "</p><p><a class=\"rdd__btn\" href=\"") + url + ("\">" + rdOT("open_the_full_page_a50af89", "Open the full page", true) + "</a></p></div>");
      entry.title = rdOT("could_not_load_c735d3a", "Could not load");
      if (stack[stack.length - 1] === entry) titleEl.textContent = entry.title;
    });
  }

  /* ------------------------------------------------------------ form ---- */
  var TEMA = [['', rdOT("choose_optional_9c82d3d", "Choose (optional)")], ['objednavka', rdOT("question_about_an_order_096c326", "Question about an order")], ['doruceni', rdOT("delivery_9631af5", "Delivery")], ['vraceni', rdOT("returns_9582a02", "Returns")], ['reklamace', rdOT("complaint_949af86", "Complaint")], ['produkt', rdOT("question_about_a_product_dd89422", "Question about a product")], ['vlastni-design', rdOT("custom_design_0ac3b2d", "Custom design")], ['jine', rdOT("something_else_48f88ac", "Something else")]];
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pageCtx() {
    var M = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product, h1 = document.querySelector('h1');
    var prod = (M && M.variants && M.variants[0] && M.variants[0].name) || (pageType() === 'product' && h1 ? h1.textContent.trim() : '');
    return { produkt: String(prod || '').slice(0, 120), url: location.href.replace(/[?&](rd_text|rd_thread|rd_open)=[^&]*/g, '').slice(0, 500), varianta: new URLSearchParams(location.search).get('variant') || '', stranka: (document.title || '').slice(0, 200) };
  }
  function formHtml(o, id) {
    var useZ = !!CONF.photos;
    var sel = TEMA.map(function (t) { return '<option value="' + t[0] + '"' + (o.tema === t[0] ? ' selected' : '') + '>' + t[1] + '</option>'; }).join('');
    return '<div class="rdd__content rdd__content--form">' +
      '<p class="rdd__lead">' + esc(o.lead || rdOT("write_to_us_and_we_will_reply_by_email_no_need_t_ab02a63", "Write to us and we will reply by email. No need to switch to your mail app.")) + '</p>' +
      '<form class="rdf" novalidate data-rdf>' +
      '<label class="rdf__l" for="' + id + ("-t\">" + rdOT("topic_7e13bd1", "Topic", true) + "</label><select class=\"rdf__in\" id=\"") + id + '-t" name="tema">' + sel + '</select>' +
      '<label class="rdf__l" for="' + id + ("-n\">" + rdOT("name_709a232", "Name", true) + "</label><input class=\"rdf__in\" id=\"") + id + '-n" name="jmeno" type="text" autocomplete="name" maxlength="100" required>' +
      '<label class="rdf__l" for="' + id + ("-e\">" + rdOT("email_84add5b", "Email", true) + "</label><input class=\"rdf__in\" id=\"") + id + ("-e\" name=\"email\" type=\"email\" autocomplete=\"email\" inputmode=\"email\" maxlength=\"200\" required placeholder=\"" + rdOT("you_email_com_36695bc", "you@email.com", true) + "\">") +
      '<label class="rdf__l" for="' + id + ("-o\">" + rdOT("order_number_fa88df2", "Order number ", true) + "<span>" + rdOT("optional_b16c7ac", "(optional)", true) + "</span></label><input class=\"rdf__in\" id=\"") + id + ("-o\" name=\"objednavka\" type=\"text\" maxlength=\"40\" autocomplete=\"off\" placeholder=\"" + rdOT("you_can_find_it_in_your_order_confirmation_a6f53e9", "You can find it in your order confirmation", true) + "\">") +
      '<label class="rdf__l" for="' + id + ("-m\">" + rdOT("message_68f4145", "Message", true) + "</label><textarea class=\"rdf__in\" id=\"") + id + '-m" name="zprava" rows="5" maxlength="2800" required></textarea>' +
      (useZ ? '<label class="rdf__l" for="' + id + ("-f\">" + rdOT("photo_8384301", "Photo ", true) + "<span>" + rdOT("optional_up_to_3_files_5_mb_in_total_7a8e136", "(optional, up to 3 files, 5 MB in total)", true) + "</span></label><input class=\"rdf__in rdf__file\" id=\"") + id + '-f" name="foto" type="file" accept="image/png,image/jpeg,image/webp" multiple>' : '') +
      ("<div class=\"rdf__hp\" aria-hidden=\"true\"><label>" + rdOT("leave_empty_ba5639a", "Leave empty", true) + "<input type=\"text\" name=\"hp\" tabindex=\"-1\" autocomplete=\"off\"></label></div>") +
      '<p class="rdf__err" role="alert" hidden data-rdf-err></p>' +
      ("<button type=\"submit\" class=\"rdd__btn rdd__btn--main\" data-rdf-go>" + rdOT("send_message_c70a890", "Send message", true) + "</button>") +
      ("<p class=\"rdf__gdpr\">" + rdOT("by_sending_this_you_agree_to_us_processing_your__0a2fcdb", "By sending this you agree to us processing your personal data to answer your enquiry. ", true) + "<a href=\"") + CONF.privacy + ("\" data-rd-drawer>" + rdOT("privacy_policy_7ceacdc", "Privacy policy", true) + "</a>.</p>") +
      '</form>' +
      ("<p class=\"rdf__alt\">" + rdOT("prefer_social_media_85b6292", "Prefer social media? ", true) + "<a href=\"") + CONF.instagram + ("\" target=\"_blank\" rel=\"noopener\">" + rdOT("message_us_on_instagram_capkov_eu_00006fa", "Message us on Instagram @capkov_eu", true) + "</a>.</p>") +
      '</div>' +
      '<div class="rdd__content rdf__ok" hidden role="status" data-rdf-ok></div>';
  }
  function bindForm(panel, o) {
    var form = panel.querySelector('[data-rdf]'), err = panel.querySelector('[data-rdf-err]'), go = panel.querySelector('[data-rdf-go]'), ok = panel.querySelector('[data-rdf-ok]');
    var f = form.elements, sending = false;
    if (o.message) f.zprava.value = o.message;
    function fail(m) { err.textContent = m; err.hidden = false; go.disabled = false; go.textContent = rdOT("send_message_c70a890", "Send message"); sending = false; }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (sending) return; err.hidden = true;
      var jm = f.jmeno.value.trim(), em = f.email.value.trim(), ms = f.zprava.value.trim(), ob = f.objednavka.value.trim(), tema = f.tema.value;
      if (!jm) { fail(rdOT("please_enter_your_name_fffccfb", "Please enter your name.")); f.jmeno.focus(); return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(em)) { fail(rdOT("please_enter_a_valid_email_address_d2306dd", "Please enter a valid email address.")); f.email.focus(); return; }
      if (ms.length < 5) { fail(rdOT("please_write_a_message_at_least_a_few_words_fe71dcb", "Please write a message (at least a few words).")); f.zprava.focus(); return; }
      if (ob && !/^[\w#\- ]{1,40}$/.test(ob)) { fail(rdOT("the_order_number_can_only_contain_letters_digits_2086443", "The order number can only contain letters, digits, # and a hyphen.")); f.objednavka.focus(); return; }
      var files = f.foto && f.foto.files ? [].slice.call(f.foto.files) : [];
      if (files.length > 3) { fail(rdOT("please_upload_at_most_3_photos_57da087", "Please upload at most 3 photos.")); return; }
      if (files.reduce(function (s, x) { return s + x.size; }, 0) > 5 * 1024 * 1024) { fail(rdOT("the_photos_are_larger_than_5_mb_in_total_d7e47b2", "The photos are larger than 5 MB in total.")); return; }
      sending = true; go.disabled = true; go.textContent = rdOT("sending_cf76551", "Sending…");
      var ctx = pageCtx(), temaLabel = (TEMA.filter(function (t) { return t[0] === tema; })[0] || [])[1] || '';
      var wait = Math.max(0, CONF.minMs - (Date.now() - formOpenedAt));
      setTimeout(function () {
        var t = Date.now() - formOpenedAt, req;
        var fd = new FormData();
        fd.append('jmeno', jm); fd.append('email', em); fd.append('objednavka', ob); fd.append('tema', temaLabel); fd.append('zprava', ms);
        fd.append('kontext_produkt', ctx.produkt); fd.append('kontext_url', ctx.url); fd.append('kontext_varianta', ctx.varianta); fd.append('kontext_stranka', ctx.stranka); fd.append('kontext_shop', location.hostname);
        fd.append('locale', ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 5));
        fd.append('market', 'eu'); fd.append('language', 'en');
        fd.append('hp', f.hp.value); fd.append('t', String(t)); files.forEach(function (x) { fd.append('foto', x, x.name); });
        req = { url: CONF.endpoint, init: { method: 'POST', body: fd, credentials: 'omit' } };
        var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { if (ctl) ctl.abort(); }, 45000);
        if (ctl) req.init.signal = ctl.signal;
        fetch(req.url, req.init).then(function (r) {
          clearTimeout(to);
          if (r.status === 200) {
            panel.querySelector('.rdd__content--form').hidden = true; ok.hidden = false;
            ok.innerHTML = ("<svg viewBox=\"0 0 24 24\" width=\"48\" height=\"48\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M8 12.5l3 3 5-6\"/></svg><h3>" + rdOT("message_sent_9cf1b68", "Message sent", true) + "</h3><p>" + rdOT("thanks_543b9b2", "Thanks, ", true) + "") + esc(jm) + rdOT("we_will_reply_by_email_to_e1268f6", ". We will reply by email to ", true) + esc(em) + '.</p>' + (panel.hasAttribute('data-rd-inline') ? '' : ("<button type=\"button\" class=\"rdd__btn rdd__btn--main\" data-rdd-close>" + rdOT("close_bbfa773", "Close", true) + "</button>")) + '';
            form.reset(); var b = ok.querySelector('button'); if (b) b.focus();
            return;
          }
          return r.json().catch(function () { return {}; }).then(function (j) {
            fail(j.error || (r.status === 429 ? rdOT("too_many_messages_in_a_short_time_please_try_aga_42d3166", "Too many messages in a short time. Please try again later.") : rdOT("sending_failed_please_try_again_in_a_moment_or_w_d3662f3", "Sending failed. Please try again in a moment, or write to us at ") + CONF.mail + '.'));
          });
        }).catch(function () { clearTimeout(to); fail(rdOT("the_connection_failed_please_try_again_in_a_mome_f9b0ab1", "The connection failed. Please try again in a moment, or write to us at ") + CONF.mail + '.'); });
      }, wait);
    });
  }
  var CTA_DEFAULT = rdOT("message_us_10d2130", "Message us");
  var nodeSeq = 0;
  function openNode(title, node, from, opts) {
    opts = opts || {};
    openShell(from);
    var key = 'n:' + (nodeSeq++), panel = document.createElement('section');
    panel.className = 'rdd__panel'; panel.hidden = true; var w = document.createElement('div'); w.className = 'rdd__content rdd__how'; w.appendChild(node); panel.appendChild(w);
    bodyEl.appendChild(panel); panels[key] = panel;
    stack = stack.filter(function (s) { if (s.key.indexOf('n:') === 0) { s.panel.remove(); delete panels[s.key]; return false; } return true; });
    push({ key: key, panel: panel, title: title, full: opts.full || null, ctaLabel: opts.cta || '', tema: opts.tema || '' });
  }
  var formSeq = 0;
  function openContact(o, from) {
    o = o || {};
    openShell(from);
    var key = 'c:' + (formSeq++), panel = document.createElement('section');
    panel.className = 'rdd__panel'; panel.hidden = true; panel.innerHTML = formHtml(o, 'rdf' + formSeq); bodyEl.appendChild(panel); panels[key] = panel;
    /* always a fresh form (no old filled fields from another enquiry); the old panel is cleaned up */
    stack = stack.filter(function (s) { if (s.key.indexOf('c:') === 0) { s.panel.remove(); delete panels[s.key]; return false; } return true; });
    formOpenedAt = Date.now(); bindForm(panel, o);
    push({ key: key, panel: panel, title: o.title || rdOT("write_to_us_32d5db4", "Write to us"), full: null, focus: o.message ? '[name=jmeno]' : '[name=jmeno]' });
  }
  function fromMailto(h) {
    var o = {}, q = (h.split('?')[1] || '');
    try { var p = new URLSearchParams(q); if (p.get('subject')) o.message = p.get('subject') + (p.get('body') ? '\n\n' + p.get('body') : '') + '\n'; else if (p.get('body')) o.message = p.get('body'); } catch (e) { }
    return o;
  }

  /* embedded form (snippet capkov-rd-contact-form): <div data-rd-contact-inline data-context="dilna|pdp|faq"> */
  var CTX_TEMA = { pdp: 'produkt', dilna: 'vlastni-design', faq: 'jine', doruceni: 'doruceni', reklamace: 'reklamace' };
  function mountInline(el) {
    if (el.getAttribute('data-rd-mounted')) return; el.setAttribute('data-rd-mounted', '1');
    var c = el.getAttribute('data-context') || '', o = { tema: CTX_TEMA[c] || '', lead: el.getAttribute('data-lead') || '' };
    var box = document.createElement('div'); box.setAttribute('data-rd-inline', c || '1'); box.className = 'rdd__inline';
    box.innerHTML = formHtml(o, 'rdi' + (formSeq++)); var ns = el.querySelector('noscript'); if (ns) ns.remove();
    el.appendChild(box); formOpenedAt = formOpenedAt || Date.now(); bindForm(box, o);
    var fo = box.querySelector('[data-rdf]'); fo.addEventListener('focusin', function () { formOpenedAt = Math.min(formOpenedAt, Date.now() - 0); }, { once: true });
  }
  function mountAll() { [].forEach.call(document.querySelectorAll('[data-rd-contact-inline]'), mountInline); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
  if (window.MutationObserver) new MutationObserver(function () { if (document.querySelector('[data-rd-contact-inline]:not([data-rd-mounted])')) mountAll(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ------------------------------------------------------------ events ---- */
  function onBodyClick(e) {
    var c = e.target.closest && e.target.closest('[data-rdd-close]'); if (c) { close(); return; }
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href');
    if (h.charAt(0) === '#' && h.length > 1) {
      var t = null; try { t = bodyEl.querySelector('[id="' + h.slice(1).replace(/"/g, '') + '"]'); } catch (x) { }
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var r = classifyLoose(a); if (!r) { if (!a.target && a.origin === location.origin) { /* another link on the site: close the panel and navigate */ closeNow(); } return; }
    e.preventDefault();
    if (r.kind === 'contact') openContact(r.mailto ? fromMailto(r.mailto) : {}, opener); else openPage(r.url, opener);
  }
  function closeNow() { if (pushed) { pushed = false; try { history.back(); } catch (e) { } } }
  /* inside the panel links apply without the page-type restriction */
  function classifyLoose(a) {
    var h = a.getAttribute('href') || '';
    if (/^mailto:/i.test(h)) return { kind: 'contact', mailto: h };
    if (a.hasAttribute('data-rd-contact')) return { kind: 'contact' };
    var n = norm(a); if (!n) return null;
    var m = n.path.match(/^\/(pages|policies)\/([^/]+)/); if (!m) return null;
    if (m[1] === 'pages' && CONTACT_PAGES.indexOf(m[2]) > -1) return { kind: 'contact' };
    if (m[1] === 'policies' || INFO_PAGES.indexOf(m[2]) > -1 || a.hasAttribute('data-rd-drawer')) return { kind: 'page', url: n.url.pathname + n.url.search };
    return null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href], [data-rd-contact]'); if (!a) return;
    if (a.closest && a.closest('.rdd')) return;
    if (a.closest && a.closest('[data-rd-consult]')) return; /* „Poradit s návrhem“ otevírá vlastní popup (capkov-rd-consult.js), ne obecný panel – jinak se otevřou oba */
    if (a.tagName !== 'A') { e.preventDefault(); openContact({ tema: a.getAttribute('data-tema') || '', message: a.getAttribute('data-message') || '' }, a); return; }
    var r = classify(a); if (!r) return;
    e.preventDefault();
    if (r.kind === 'contact') openContact(r.mailto ? fromMailto(r.mailto) : { tema: a.getAttribute('data-tema') || '' }, a); else openPage(r.url, a);
  });
  /* prefetch on hover / touch */
  function warm(e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || (a.closest && a.closest('.rdd'))) return;
    var r = classify(a); if (r && r.kind === 'page') load(r.url).catch(function () { });
  }
  document.addEventListener('pointerenter', warm, true);
  document.addEventListener('touchstart', warm, { passive: true, capture: true });

  window.rdDrawer = { openNode: openNode, mountInline: mountAll, open: function (u, from) { openPage(u, from); }, contact: function (o, from) { openContact(o, from); }, close: close, config: CONF };
})();

})();
